import { render, staticRenderFns } from "./CreatureHeading.vue?vue&type=template&id=5f6b2ee1&"
import script from "./CreatureHeading.vue?vue&type=script&lang=js&"
export * from "./CreatureHeading.vue?vue&type=script&lang=js&"
import style0 from "./CreatureHeading.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports